import React$1 from 'react';
import { ComboBoxContext } from '../ComboBox/context.js';
import { TextField as TextField$2 } from '../../../TextField/TextField.js';

function TextField(props) {
  return /*#__PURE__*/React$1.createElement(ComboBoxContext.Consumer, null, ({
    selectedOptionId,
    comboBoxId
  }) => /*#__PURE__*/React$1.createElement(TextField$2, Object.assign({}, props, {
    autoComplete: false,
    ariaAutocomplete: "list",
    ariaActiveDescendant: selectedOptionId,
    ariaControls: comboBoxId
  })));
}

export { TextField };
